import Box from "@@/elements/Box";
import { Check } from "@@/elements/Icons/icons";
import Typhography from "@@/elements/Typography";
import cn from "classnames";
import styles from "./optionStyles.module.scss";

type DropdownOptionOwnProps = {
  id: string;
  isActive: boolean;
  checked: boolean;
  disabled?: boolean;
  handleChange: Function;
  singleSelect?: boolean;
};

export type DropdownOptionProps = {
  label: string;
  value: string;
  count?: number;
  disabled?: boolean;
};

type DropdownOptionAllProps = DropdownOptionOwnProps & DropdownOptionProps;

const DropdownOption = ({
  id, label, value, count, checked, isActive, disabled = false, handleChange, singleSelect = false,
} : DropdownOptionAllProps) => {
  const countString = `(${count})`;

  return (
    <div
      id={id}
      className={cn(styles.option, { [styles.option__active]: isActive })}
      role="option"
      aria-selected={checked}
    >
      <input
        id={`${id}-input`}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={() => {
          handleChange(value);
        }}
        tabIndex={-1}
      />
      <label className={styles.container} htmlFor={`${id}-input`}>
        <Box className={styles.label}>
          <Typhography
            variant="label"
            asElement="div"
            uppercase
            bold={singleSelect && checked}
          >
            {label}
          </Typhography>
          {count != null && (
          <Box alignItems="baseline" height="full" className={styles.count}>
            <Typhography variant="label" asElement="div">
              {countString}
            </Typhography>
          </Box>
          )}
        </Box>
        {!singleSelect && (
        <span className={cn(styles.icon_wrapper, styles.icon_wrapper__checkmark)}>
          {checked && (
          <Check className={styles.checkmark_icon} />
          )}
        </span>
        )}
      </label>
    </div>
  );
};

export default DropdownOption;
